import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import TenantAuditReportView from './TenantAuditReportView'

const TenantAuditReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Tenant Audit Report" mainTitle="Tenant Audit Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <TenantAuditReportView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default TenantAuditReport